import axios from "axios";
import AES from "@/utils/aes";
import { urlRegex, getInfoKeyValue } from "@/utils/index";
import { useSystemConfigStore } from "../stores/systemConfig";
import { ElMessage } from "element-plus";

const request = axios.create({
  timeout: 60000,
  baseURL: import.meta.env.VITE_BASE_URL,
});

// request interceptor
request.interceptors.request.use(
  (config) => {
    const systemConfigStore = useSystemConfigStore();
    // config.baseURL = baseURL;

    config.headers = {
      ...config.headers,
      x: "",
      uri: "",
      tenantId: 1,
      timezone: "UTC-8",
      userId: 0,
      systemId: 1,
      language: systemConfigStore.language,
      country: systemConfigStore.currentCountryObj.countryNameAbbr,
    };

    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
request.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;

    // 特殊接口 不需要接口请求拦截
    const urlArrs = new Set(["/ext/user/operate/log/save"]);
    if (urlArrs.has(response.config.url)) {
      return res;
    }

    if (res.code !== "C00001" && res.code !== "POP0001" && res.code !== '900066') {
      ElMessage({
        message: res.description || showI18nText("text78", "system"),
        type: "error",
        duration: 5 * 1000,
      });
    }

    if (['900066'].includes(res.code)) {
      return Promise.reject(response.data);
    }

    return res;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export default request;
